// UI strings for the note under a show line with a documented error (components/LineErrata.tsx;
// DialogueLine.errata from data/curated/show-notes/peterson.json): who said it, what it should be
// and what was heard in the show, then where and when it was said and the source link
// (community/SourceLine.tsx: "AO3 24.10.2022 · lähde"). Information only: the line stays as aired.
// Finnish (default) and English side by side; en has the same shape. Style: docs/FINNISH-STYLE.md.
import { defineArea } from '../area';

export const lineErrataFi = {
  /** Who documented the error: Peterson himself, or only the wiki's footnote. */
  by: { peterson: 'Peterson:', wiki: 'Wikin alaviite:' },
  /** "tässä pitäisi olla <expected> – sarjassa kuultu <heard> on virhe." in three pieces. */
  should: 'tässä pitäisi olla',
  heard: '– sarjassa kuultu',
  isError: 'on virhe.',
  /** On-screen writing (LineErratum.seen: Talisa's letter): seen, not heard; the wiki's own text, not a footnote. */
  seenBy: { peterson: 'Peterson:', wiki: 'Wiki:' },
  seen: '– ruudulla näkyvä',
  isSeenError: 'on virhe.',
};

export const lineErrataEn: typeof lineErrataFi = {
  by: { peterson: 'Peterson:', wiki: 'Wiki footnote:' },
  should: 'this should be',
  heard: '– the',
  isError: 'heard in the show is an error.',
  seenBy: { peterson: 'Peterson:', wiki: 'Wiki:' },
  seen: '– the',
  isSeenError: 'seen on screen is an error.',
};

// Messages.lineErrata (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('lineErrata', lineErrataFi, lineErrataEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof lineErrataFi> {}
}
